import clsx from "clsx";

// Matches the existing `p-4 text-red-600` pattern used verbatim across Grows.jsx,
// Recipes.jsx, RecipeDetail.jsx — unifies rendering only, callers keep their own copy.
export default function ErrorState({ children, className }) {
  return <div className={clsx("p-4 text-danger dark:text-danger-onDark", className)}>{children}</div>;
}
